import { render, staticRenderFns } from "./combinListDetail.vue?vue&type=template&id=233a405e&scoped=true&"
import script from "./combinListDetail.vue?vue&type=script&lang=js&"
export * from "./combinListDetail.vue?vue&type=script&lang=js&"
import style0 from "./combinListDetail.vue?vue&type=style&index=0&id=233a405e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a405e",
  null
  
)

export default component.exports